import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAdminAuthStore } from '../stores/auth';
import { clearSessionTokens } from '../api';

declare module 'vue-router' {
  interface RouteMeta {
    title?: string;
    permission?: string;
    public?: boolean;
  }
}

const routes: RouteRecordRaw[] = [
  { path: '/login', name: 'login', component: () => import('../views/LoginView.vue'), meta: { title: '后台登录', public: true } },
  {
    path: '/',
    component: () => import('../layouts/AdminLayout.vue'),
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', component: () => import('../views/DashboardView.vue'), meta: { title: '数据大盘', permission: 'dashboard:view' } },
      { path: 'users', component: () => import('../views/UsersView.vue'), meta: { title: '用户管理', permission: 'user:view' } },
      { path: 'users/:id', component: () => import('../views/UserDetailView.vue'), meta: { title: '用户详情', permission: 'user:view' } },
      { path: 'matching', component: () => import('../views/MatchingView.vue'), meta: { title: '匹配与推荐', permission: 'matching:view' } },
      { path: 'content', component: () => import('../views/ContentView.vue'), meta: { title: '内容与互动', permission: 'content:view' } },
      { path: 'risk', component: () => import('../views/RiskView.vue'), meta: { title: '风控与工单', permission: 'risk:review' } },
      { path: 'finance', component: () => import('../views/FinanceView.vue'), meta: { title: '订单管理', permission: 'finance:view' } },
      { path: 'leaderboard', component: () => import('../views/LeaderboardView.vue'), meta: { title: '榜单管理', permission: 'leaderboard:view' } },
      { path: 'operations', component: () => import('../views/OperationsView.vue'), meta: { title: '运营配置', permission: 'operation:manage' } },
      { path: 'system', component: () => import('../views/SystemView.vue'), meta: { title: '系统配置', permission: 'config:view' } },
      { path: 'forbidden', component: () => import('../views/ForbiddenView.vue'), meta: { title: '无权访问' } },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
];

export const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach(async (to) => {
  const auth = useAdminAuthStore();
  await auth.initialize();
  document.title = `${to.meta.title || '运营后台'} - 怦怦`;
  if (to.meta.public) return auth.authenticated ? '/dashboard' : true;
  if (!auth.authenticated) return { path: '/login', query: { redirect: to.fullPath } };
  if (to.meta.permission && !auth.has(to.meta.permission)) return '/forbidden';
  return true;
});

window.addEventListener('pengpeng-admin:auth-required', () => {
  const auth = useAdminAuthStore();
  auth.admin = null;
  clearSessionTokens();
  if (router.currentRoute.value.path !== '/login') void router.replace({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } });
});
